import { DumQueryApi } from '@src/Api/generated-global-event';
import { useStores } from '@src/Common/Hooks/useStores';
import AxiosInstanceGlobalEvent from '@src/Common/Services/Api/AxiosInstanceGlobalEvent';
import { logEvent } from '@src/Domain/Analytic';
import { AnalyticsEvent } from '@src/Domain/Analytic/Analytic.type';
import {
  IDumGlobalEventDetailHoverData,
  IMapCoordinate
} from '@src/Domain/DUMEvents/DUMEvents.type';
import { AxiosInstance } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

const lDEQa = (AI: AxiosInstance) => new DumQueryApi(undefined, '', AI);

const useDetailEventPopup = (eventData: IMapCoordinate) => {
  const { isAuthenticated } = useAuth();
  const { DUMEventStore, FormStore, UiStore } = useStores();
  const { data: detailEvent } = DUMEventStore.detailEventData;
  const [selectedGlobalData, setSelectedGlobalData] = useState<
    IDumGlobalEventDetailHoverData | undefined
  >(undefined);
  const [typeEvent, setTypeEvent] = useState<string | undefined>('');

  const fetchDUMEvent = lDEQa(AxiosInstanceGlobalEvent(''));

  const handleDetailvents = useCallback(() => {
    if (DUMEventStore.selectedDetailDumGlobalIdIndex !== undefined) {
      const selectedGlobal =
        eventData.hoverData[DUMEventStore.selectedDetailDumGlobalIdIndex];
      setSelectedGlobalData(selectedGlobal);
      if (selectedGlobal.type) setTypeEvent(selectedGlobal.type);
      if (selectedGlobal.globalEventId) {
        DUMEventStore.getDetailEvent(
          selectedGlobal.globalEventId?.toString(),
          selectedGlobal.type,
          fetchDUMEvent
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DUMEventStore.selectedDetailDumGlobalIdIndex]);

  useEffect(() => {
    handleDetailvents();
  }, [handleDetailvents, DUMEventStore.selectedDetailDumGlobalIdIndex]);

  const handleClickBtn = () => {
    if (
      detailEvent &&
      selectedGlobalData?.type === 'casefile' &&
      detailEvent.product_reference
    ) {
      window.open(detailEvent.product_reference ?? '');
      logEvent(AnalyticsEvent.LINK_VISITED, 'DUM Product Reference Click');
    }
  };

  const checkCoordinate = (value?: number) => {
    if (value) return Number(value).toFixed(6);
    return 0;
  };

  const onOpenSource = () => {
    window.open(detailEvent?.product_reference ?? '');
    logEvent(AnalyticsEvent.LINK_VISITED, 'DUM Product Reference Click');
  };

  const onNextGlobalData = () => {
    const currentIndex = DUMEventStore.selectedDetailDumGlobalIdIndex ?? 0;
    if (currentIndex + 1 < eventData.hoverData.length) {
      DUMEventStore.selectedDetailDumGlobalIdIndex = currentIndex + 1;
    } else {
      // go to first hoverData
      DUMEventStore.selectedDetailDumGlobalIdIndex = 0;
    }
  };

  const onPreviousGlobalData = () => {
    const currentIndex = DUMEventStore.selectedDetailDumGlobalIdIndex ?? 0;
    if (currentIndex > 0) {
      DUMEventStore.selectedDetailDumGlobalIdIndex = currentIndex - 1;
    } else {
      // go to last hoverData
      DUMEventStore.selectedDetailDumGlobalIdIndex =
        eventData.hoverData.length - 1;
    }
  };

  const onPlusClick = () => {
    if (!isAuthenticated) {
      // show modal dialog login
      UiStore.showModalAccountRequired = true;
    } else {
      FormStore.isDetailVisible = true;
      FormStore.selectedEvent = selectedGlobalData;
    }
  };

  return {
    typeEvent,
    setTypeEvent,
    handleClickBtn,
    checkCoordinate,
    selectedGlobalData,
    setSelectedGlobalData,
    onOpenSource,
    onNextGlobalData,
    onPreviousGlobalData,
    onPlusClick,
    anomalyRating: Number(
      detailEvent?.custom_attributes?.find((v) => v.name === 'anomaly_rating')
        ?.value
    )
  };
};

export default useDetailEventPopup;
